import { MenuItem, TextField } from "@mui/material";
import { useTiposEnviosGateway } from "../../api/ESocialJTServiceApi";

function TipoEventoGateway({ value, onChange, ...props }) {
  const { data: tipos = [] } = useTiposEnviosGateway();

  return (
    <TextField
      select
      fullWidth
      size="small"
      label="Tipo"
      value={value}
      onChange={onChange}
      {...props}
    >
      <MenuItem value="">
        <em>Todos</em>
      </MenuItem>
      {tipos.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default TipoEventoGateway;
